import { render, staticRenderFns } from "./EducationalRatingChangeActivationType.vue?vue&type=template&id=973c9c3c&"
import script from "./EducationalRatingChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports